// import React, { useState, useEffect } from 'react';
// import API from '../utils/axiosInstance';

// const BookAppointment = () => {
//   const [formData, setFormData] = useState({
//     patientFirstName: '',
//     patientLastName: '',
//     patientEmail: '',
//     patientNumber: '',
//     patientAddress: '',
//     appointmentDate: '',
//     startTime: '',
//     endTime: '',
//     doctorId: '',
//     status: 'Scheduled',
//     reason: '',
//     priority: '',
//     appointmentType: '',
//     slotId: ''
//   });

//   const [doctors, setDoctors] = useState([]);
//   const [slots, setSlots] = useState([]);

//   useEffect(() => {
//     API.get('/v1/users')
//       .then((res) => {
//         const doctorList = res.data.filter((u) => u.roles?.some((r) => r.name === 'DOCTOR'));
//         setDoctors(doctorList);
//       })
//       .catch((err) => console.error('Error fetching doctors:', err));
//   }, []);

//   useEffect(() => {
//     if (formData.doctorId && formData.appointmentDate) {
//       API.get(`/v1/appointments/slots/all?doctorId=${formData.doctorId}&date=${formData.appointmentDate}`)
//         .then((res) => setSlots(res.data))
//         .catch((err) => console.error('Error fetching slots:', err));
//     }
//   }, [formData.doctorId, formData.appointmentDate]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === 'startTime') {
//       const selectedSlot = slots.find((s) => s.startTime === value);
//       setFormData((prev) => ({
//         ...prev,
//         startTime: value,
//         endTime: selectedSlot?.endTime || '',
//         slotId: selectedSlot?.slotId || ''
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const appointmentForm = async (e) => {
//     e.preventDefault();
//     try {
//       await API.post('/v1/appointments/book', formData);
//       alert('Appointment booked successfully');
//       setFormData({
//         patientFirstName: '',
//         patientLastName: '',
//         patientEmail: '',
//         patientNumber: '',
//         patientAddress: '',
//         appointmentDate: '',
//         startTime: '',
//         endTime: '',
//         doctorId: '',
//         status: 'Scheduled',
//         reason: '',
//         priority: '',
//         appointmentType: '',
//         slotId: ''
//       });
//     } catch (err) {
//       console.error('Booking failed:', err);
//       alert('Failed to book appointment');
//     }
//   };

//   return (
//     <div className="col-lg-12 mx-auto mt-5">
//       <div className="appointment-form rounded p-5 shadow border">
//         <p className="fs-4 text-uppercase text-primary">Get In Touch</p>
//         <h1 className="display-5 mb-4">Get Appointment</h1>
//         <form onSubmit={appointmentForm}>
//           <div className="row gy-3 gx-4">
//             <div className="col-xl-6">
//               <input type="text" name="patientFirstName" value={formData.patientFirstName} onChange={handleChange} className="form-control py-3 border-primary bg-transparent text-dark" placeholder="First Name" required />
//             </div>
//             <div className="col-xl-6">
//               <input type="text" name="patientLastName" value={formData.patientLastName} onChange={handleChange} className="form-control py-3 border-primary bg-transparent text-dark" placeholder="Last Name" required />
//             </div>
//             <div className="col-xl-6">
//               <input type="email" name="patientEmail" value={formData.patientEmail} onChange={handleChange} className="form-control py-3 border-primary bg-transparent text-dark" placeholder="Email" required />
//             </div>
//             <div className="col-xl-6">
//               <input type="tel" name="patientNumber" value={formData.patientNumber} onChange={handleChange} className="form-control py-3 border-primary bg-transparent text-dark" placeholder="Mobile" required />
//             </div>
//             <div className="col-xl-6">
//               <input type="text" name="patientAddress" value={formData.patientAddress} onChange={handleChange} className="form-control py-3 border-primary bg-transparent text-dark" placeholder="Address" required />
//             </div>
//             <div className="col-xl-6">
//               <input type="date" name="appointmentDate" value={formData.appointmentDate} onChange={handleChange} className="form-control py-3 border-primary bg-transparent text-dark" required />
//             </div>
//             <div className="col-xl-6">
//               <select name="doctorId" value={formData.doctorId} onChange={handleChange} className="form-select py-3 border-primary bg-transparent text-dark" required>
//                 <option value="">Select Doctor</option>
//                 {doctors.map((doc) => (
//                   <option key={doc.id} value={doc.id}>{doc.fullName}</option>
//                 ))}
//               </select>
//             </div>
//             <div className="col-xl-6">
//               <select name="startTime" value={formData.startTime} onChange={handleChange} className="form-select py-3 border-primary bg-transparent text-dark" required>
//                 <option value="">Select Slot</option>
//                 {slots.map((slot) => (
//                   <option key={slot.slotId} value={slot.startTime}>{slot.startTime} - {slot.endTime}</option>
//                 ))}
//               </select>
//             </div>
//             <div className="col-xl-6">
//               <input type="text" name="reason" value={formData.reason} onChange={handleChange} className="form-control py-3 border-primary bg-transparent text-dark" placeholder="Reason" required />
//             </div>
//             <div className="col-xl-6">
//               <select name="priority" value={formData.priority} onChange={handleChange} className="form-select py-3 border-primary bg-transparent text-dark" required>
//                 <option value="">Priority</option>
//                 <option value="Low">Low</option>
//                 <option value="Medium">Medium</option>
//                 <option value="High">High</option>
//               </select>
//             </div>
//             <div className="col-xl-6">
//               <select name="appointmentType" value={formData.appointmentType} onChange={handleChange} className="form-select py-3 border-primary bg-transparent text-dark" required>
//                 <option value="">Appointment Type</option>
//                 <option value="Consultation">Consultation</option>
//                 <option value="Follow-up">Follow-up</option>
//               </select>
//             </div>
//             <div className="col-12">
//               <button type="submit" className="btn btn-primary text-white w-100 py-3 px-5">SUBMIT NOW</button>
//             </div>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default BookAppointment;

import React, { useState, useEffect } from 'react';
import API from '../utils/axiosInstance';

const BookAppointment = () => {
  const [formData, setFormData] = useState({
    patientFirstName: '',
    patientLastName: '',
    patientEmail: '',
    patientNumber: '',
    patientAddress: '',
    appointmentDate: '',
    startTime: '',
    endTime: '',
    doctorId: '',
    status: 'Scheduled',
    reason: '',
    priority: '',
    appointmentType: '',
    slotId: ''
  });

  const [doctors, setDoctors] = useState([]);
  const [slots, setSlots] = useState([]);

  useEffect(() => {
    API.get('/v1/users')
      .then((res) => {
        const doctorList = res.data.filter((u) => u.roles?.some((r) => r.name === 'DOCTOR'));
        setDoctors(doctorList);
      })
      .catch((err) => console.error('Error fetching doctors:', err));
  }, []);

  useEffect(() => {
    if (formData.doctorId && formData.appointmentDate) {
      API.get(`/v1/appointments/slots/all?doctorId=${formData.doctorId}&date=${formData.appointmentDate}`)
        .then((res) => setSlots(res.data))
        .catch((err) => console.error('Error fetching slots:', err));
    }
  }, [formData.doctorId, formData.appointmentDate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'startTime') {
      const selectedSlot = slots.find((s) => s.startTime === value);
      setFormData((prev) => ({
        ...prev,
        startTime: value,
        endTime: selectedSlot?.endTime || '',
        slotId: selectedSlot?.slotId || ''
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const appointmentForm = async (e) => {
    e.preventDefault();
    try {
      await API.post('/v1/appointments/book', formData);
      alert('Appointment booked successfully');
      setFormData({
        patientFirstName: '',
        patientLastName: '',
        patientEmail: '',
        patientNumber: '',
        patientAddress: '',
        appointmentDate: '',
        startTime: '',
        endTime: '',
        doctorId: '',
        status: 'Scheduled',
        reason: '',
        priority: '',
        appointmentType: '',
        slotId: ''
      });
    } catch (err) {
      console.error('Booking failed:', err);
      alert('Failed to book appointment');
    }
  };

  return (
   <div className="container my-5">
    <div className="row justify-content-center">
      <div className="col-12 col-md-10 col-lg-6">
        <div className="appointment-form rounded p-4 shadow border bg-white">
          <p className="fs-4 text-uppercase text-primary">Get In Touch</p>
          <h1 className="display-6 mb-4">Book Appointment</h1>
            <form onSubmit={appointmentForm}>
              <div className="row g-3">
                <div className="col-md-6">
                  <input type="text" name="patientFirstName" value={formData.patientFirstName} onChange={handleChange} className="form-control py-2 border-primary" placeholder="First Name" required />
                </div>
                <div className="col-md-6">
                  <input type="text" name="patientLastName" value={formData.patientLastName} onChange={handleChange} className="form-control py-2 border-primary" placeholder="Last Name" required />
                </div>
                <div className="col-md-6">
                  <input type="email" name="patientEmail" value={formData.patientEmail} onChange={handleChange} className="form-control py-2 border-primary" placeholder="Email" required />
                </div>
                <div className="col-md-6">
                  <input type="tel" name="patientNumber" value={formData.patientNumber} onChange={handleChange} className="form-control py-2 border-primary" placeholder="Mobile" required />
                </div>
                <div className="col-12">
                  <input type="text" name="patientAddress" value={formData.patientAddress} onChange={handleChange} className="form-control py-2 border-primary" placeholder="Address" required />
                </div>
                <div className="col-md-6">
                  <input type="date" name="appointmentDate" value={formData.appointmentDate} onChange={handleChange} className="form-control py-2 border-primary" required />
                </div>
                <div className="col-md-6">
                  <select name="doctorId" value={formData.doctorId} onChange={handleChange} className="form-select py-2 border-primary" required>
                    <option value="">Select Doctor</option>
                    {doctors.map((doc) => (
                      <option key={doc.id} value={doc.id}>{doc.fullName}</option>
                    ))}
                  </select>
                </div>
                <div className="col-12">
                  <select name="startTime" value={formData.startTime} onChange={handleChange} className="form-select py-2 border-primary" required>
                    <option value="">Select Slot</option>
                    {slots.map((slot) => (
                      <option key={slot.slotId} value={slot.startTime}>
                        {slot.startTime} - {slot.endTime}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12">
                  <input type="text" name="reason" value={formData.reason} onChange={handleChange} className="form-control py-2 border-primary" placeholder="Reason" required />
                </div>
                <div className="col-md-6">
                  <select name="priority" value={formData.priority} onChange={handleChange} className="form-select py-2 border-primary" required>
                    <option value="">Priority</option>
                    <option value="Low">Low</option>
                    <option value="Medium">Medium</option>
                    <option value="High">High</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <select name="appointmentType" value={formData.appointmentType} onChange={handleChange} className="form-select py-2 border-primary" required>
                    <option value="">Appointment Type</option>
                    <option value="Consultation">Consultation</option>
                    <option value="Follow-up">Follow-up</option>
                  </select>
                </div>
                <div className="col-12">
                  <button type="submit" className="btn btn-primary w-100 py-2">SUBMIT NOW</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookAppointment;
